/* Home-only JS: Fireblood product card link rewrite 
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href*="getfireblood.com"]').forEach(function(a) {
    a.href = '/pages/fireblood-tate';
  });
});
*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href]').forEach(function (a) {
    const href = a.getAttribute('href');

    if (
      /getfireblood\.com/i.test(href) ||
      /\/products\/fireblood(\?|$|\/)/i.test(href)
    ) {
      a.href = '/pages/fireblood-tate';
    }
  });
});